angular.module('myappointments').factory('MyAppointmentsRepository',
    ['AprimaRestangular', 'MetadataRepository', function (AprimaRestangular, MetadataRepository) {
        'use strict';
        
        function changeAppointmentStatus(patientId, appointmentId, statusId) {
            var restangular = AprimaRestangular.get('patient');
            return restangular.one('patients/' + patientId + '/appointments/status/' + appointmentId + '/' + statusId).customPUT();
        }

        function updateAppointment(appt) {
            var patientId = appt.Patient.Id;
            var appointmentId = appt.Id;

            var restangular = AprimaRestangular.get('patient');
            return restangular.one('patients/' + patientId + '/appointments/' + appointmentId).customPUT(appt);
        }

        function getAppointment(patientId, appointmentId) {
            var restangular = AprimaRestangular.get('patient');
            return restangular.one('patients/' + patientId + '/appointments/' + appointmentId).get();
        }

        function getAppointments(userId, searchFilter) {
            var restangular = AprimaRestangular.get('patient');
            return restangular.one('patients/' + userId).customGET('appointments', searchFilter);
        }

        function getPendingAppointments(userId) {
            var restangular = AprimaRestangular.get('patient');
            return restangular.one('patients/' + userId + '/pendingappointments').get();
        }

        //[Route("api/patient/v1/patients/{userId:Guid}/pendingappointmentrequest")]
        function getPendingAppointmentRequest(userId) {
            var restangular = AprimaRestangular.get('patient');
            return restangular.one('patients/' + userId + '/pendingappointmentrequest').get();
        }

        function getAppointmentsOpenTimeSlots(userId, calendarId, searchFilter) {
            var restangular = AprimaRestangular.get('patient');
            return restangular.one('patients/' + userId + '/calendars/' + calendarId).customGET('opentemplateslots', searchFilter);
        }

        function requestAppointment(userId, appt) {
            var restangular = AprimaRestangular.get('patient');
            return restangular.one('patients/' + userId + '/appointmentrequest').customPUT(appt);
        }

        function getAppointmentRequestMetadata($scope) {
            return MetadataRepository.getMetadata('patientappointmentrequest', $scope);
        }

        function getTimeZone() {
            var restangular = AprimaRestangular.get('patient');
            return restangular.one('patients/timezone').get();
        }

        return {
            changeAppointmentStatus: changeAppointmentStatus,
            getAppointments: getAppointments,
            getPendingAppointments: getPendingAppointments,
            getPendingAppointmentRequest: getPendingAppointmentRequest,
            getAppointmentsOpenTimeSlots: getAppointmentsOpenTimeSlots,
            requestAppointment: requestAppointment,
            getAppointment: getAppointment,
            updateAppointment: updateAppointment,
            getAppointmentRequestMetadata: getAppointmentRequestMetadata,
            getTimeZone : getTimeZone
        };

    }]);